import { configureStore } from '@reduxjs/toolkit';

import authReducer from '../store/slice/auth';
import commonReducer from '../store/slice/common';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    common: commonReducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
